import * as p from "react";
import { P as d } from "./index-Bo0P2KXg.js";
import { jsx as m } from "react/jsx-runtime";
var v = "Separator", t = "horizontal", l = ["horizontal", "vertical"], i = p.forwardRef((r, n) => {
  const { decorative: e, orientation: a = t, ...s } = r, o = f(a) ? a : t, c = e ? { role: "none" } : { "aria-orientation": o === "vertical" ? o : void 0, role: "separator" };
  return /* @__PURE__ */ m(
    d.div,
    {
      "data-orientation": o,
      ...c,
      ...s,
      ref: n
    }
  );
});
i.displayName = v;
function f(r) {
  return l.includes(r);
}
var u = i;
export {
  u as R
};
